export default __webpack_public_path__ + "static/media/radio-validation.62f0b693.svg";